import { createApp } from "vue"
import App from "./pages/App.vue"

import { loadApp } from "./utils/loadApp"

const app = createApp(App)

loadApp(app)

app.mount("#app")
